import { ISelectOption } from './../../interfaces/ISelectOption';

export const azureRegionList = [
    'Central US',
    'East US 2',
    'East US',
    'North Central US',
    'South Central US',
    'West US 2',
    'West Central US',
    'West US',
    'Canada Central',
    'Canada East',
    'Brazil South',
    'North Europe',
    'West Europe',
    'France Central',
    'France South',
    'UK South',
    'UK West',
    'Germany Central',
    'Germany Northeast',
    'Germany West Central',
    'Germany North',
    'Switzerland North',
    'Switzerland West',
    'Norway West',
    'Norway East',
    'East Asia',
    'Southeast Asia',
    'Australia Central',
    'Australia Central 2',
    'Australia East',
    'Australia Southeast',
    'China East',
    'China North',
    'China East 2',
    'China North 2',
    'Central India',
    'South India',
    'West India',
    'Japan East',
    'Japan West',
    'Korea Central',
    'Korea South',
    'US DoD Central',
    'US DoD East',
    'US Gov Arizona',
    'US Gov Iowa',
    'US Gov Texas',
    'US Gov Virginia',
    'US Sec West',
    'US Sec East',
    'South Africa North',
    'South Africa West',
    'UAE Central',
    'UAE North'
].sort();

export const azureRegionOptions: Array<ISelectOption<string>> = azureRegionList.map((v) => ({
    label: v,
    value: v
}));
